// discovering feature

export const DISCOVERING_FEATURE_VISIBILITY_DAYS = 30;

export const FILE_ACCESS_SETTINGS_BUTTON_ID = 'file-access-settings-button';

// first release date for discovering feature: 2026-05-06
export const FIRST_RELEASE_DISCOVERING_FEATURE = '2026-05-06';

// second release date for discovering feature: 2026-05-27
export const SECOND_RELEASE_DISCOVERING_FEATURE = '2026-05-27';

// third release date for discovering feature: 2026-06-03
export const THIRD_RELEASE_DISCOVERING_FEATURE = '2026-06-03';
